import { Home } from './Home.js'
import { HashRouter, Routes, Route } from 'react-router-dom'
import React, { Suspense } from 'react';
import { HashLink } from 'react-router-hash-link';
import { ContactSection } from "./Contact.js";
import BurgerMenu from './LottieAnimations/burger-menu.json'
import Lottie from 'lottie-react-web'
import XSSChall from './HomeSections/xss_chall.js';

const Projects = React.lazy(() => import('./Projects.js'));

function App() {
  return (
    <HashRouter>
      <div class="PageProgressIndicator"/>
      <Routes>
        <Route exact path='/' element={
          <>
            <HamburgerMenu/>
            <Home/>
            <ContactSection/>
          </>
        }/>
        <Route path='/projects' element={
          <>
            <HamburgerMenu/>
            <Suspense fallback={<div>Loading...</div>}>
              <Projects/>
            </Suspense>
            <ContactSection/>
          </>
        }/>
        <Route path='/reallylongandshadyurlthatleadstoashadylookingwebsitethatshoulddefinitelynotbetrusted' element={<XSSChall/>}/>
      </Routes>
    </HashRouter>
  );
}

class HamburgerMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {expanded: false};
    this.playerRef = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll)
  }

  toggle() {
    this.setState({expanded: !this.state.expanded});
  }

  onScroll() {
    this.setState({expanded: false})
      let w = (document.body.scrollTop || document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 100;
      document.querySelector('.PageProgressIndicator').style.setProperty('width', w + '%');
  }

  render() {
    return (
      <div class={this.state.expanded ? "MenuContainer expanded":"MenuContainer"}>
        <button class="burgerMenuButton" onClick={this.toggle}>
          <Lottie 
              options={{
                  animationData: BurgerMenu,
                  loop: false,
              }}
              direction={this.state.expanded ? 1 : -1}
            />
        </button>
        <div class="LinkContainer" hidden={!this.state.expanded}>
          <HashLink to="./#start" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Start</b></HashLink>
          <HashLink to="./projects#start" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Projects</b></HashLink>
          <HashLink to="./#education" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Education</b></HashLink>
          <HashLink to="./#skills" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Skills</b></HashLink>
          <HashLink to="./#certifications" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Certifications</b></HashLink>
          <HashLink to="./#languages" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Languages</b></HashLink>
          <HashLink to="./#contact" class="page_references" hidden={!this.state.expanded} onClick={this.toggle}><b>Contact</b></HashLink>
        </div>
      </div>
    );
  }
}

export default App;
